/* eslint-disable react/forbid-prop-types */
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';
import { BANKING_ELIGIBILITY_STATUS } from '#client/constants/validationMessages';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useModalDisplayTracker from '#client/hooks/useModalDisplayTracker';

import ValidationMessage from '../ValidationMessage';
import {
  ImageWrapperStyled,
  ImageStyled,
  ContentWrapperStyled,
  HeadingStyled
} from './components/MoreInfo.styles';
import { Questions } from './components/Questions';

const MoreInfo = ({
  fieldsToRender,
  dataChangeHandler = () => {},
  data = {},
  shouldShowChaseModalIfIsProhibited
}) => {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();
  /**
   * Tracking Details: Tracking to be added to the banking application Collect Info screen.
   * Question:
   *          Where are customers typically dropping off on this screen?
   *          Do they typically drop off at SSN?
   *          How often are they viewing the user agreements?
   */
  useModalDisplayTracker({
    elementName: 'banking_collect_info',
    elementText: 'banking_collect_info',
    appPageName: 'banking_collect_info'
  });

  return (
    <>
      {shouldShowChaseModalIfIsProhibited ? (
        <ValidationMessage
          validationStatus={BANKING_ELIGIBILITY_STATUS.PROHIBITED_BUSINESS_VERTICAL}
        />
      ) : (
        <ContainerGrid paddingTop={{ xs: '32px', md: '80px' }}>
          <FocusGrid>
            {isDesktop && (
              <ImageWrapperStyled>
                <ImageStyled
                  alt=""
                  src="/s2/vector/bank-jars-card-moneystack.svg"
                />
              </ImageWrapperStyled>
            )}
            <ContentWrapperStyled>
              <HeadingStyled
                family="secondary"
                size="3xl"
                weight="bold"
              >
                Now we need more info to finish your application.
              </HeadingStyled>
              <Text
                color="secondary"
                component="p"
                size="lg"
              >
                Tell us a bit more about you and your business. Then make sure to read our terms and
                conditions before moving to the next step.
              </Text>
              <Stack
                gap={isDesktop ? '40px' : '32px'}
                marginTop={isDesktop ? '40px' : '20px'}
              >
                <Questions
                  data={data}
                  dataChangeHandler={dataChangeHandler}
                  fields={fieldsToRender}
                />
                <Text
                  color="primary"
                  component="p"
                  size="lg"
                >
                  By providing the information above, I hereby certify, to the best of my knowledge,
                  that the information provided above is complete and correct
                </Text>
              </Stack>
            </ContentWrapperStyled>
          </FocusGrid>
        </ContainerGrid>
      )}
    </>
  );
};

MoreInfo.propTypes = {
  data: PropTypes.object,
  fieldsToRender: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  dataChangeHandler: PropTypes.func,
  shouldShowChaseModalIfIsProhibited: PropTypes.bool
};

export default MoreInfo;
